import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import {
  DOCUMENT_FILE__DOWNLOAD_FAILURE,
  DOCUMENT_FILE__DOWNLOAD_REQUEST,
  DOCUMENT_FILE__DOWNLOAD_SUCCESS,
  DOCUMENT_FILE__FETCH_FAILURE,
  DOCUMENT_FILE__FETCH_REQUEST,
  DOCUMENT_FILE__FETCH_SUCCESS,
} from '@app/store/actionTypes';

export function downloadDocumentFile(payload: {
  documentId: string;
  documentTitle?: string | null;
}) {
  return {
    type: DOCUMENT_FILE__DOWNLOAD_REQUEST,
    payload,
  };
}
export const downloadDocumentFileSuccess = createAction(DOCUMENT_FILE__DOWNLOAD_SUCCESS);
export function downloadDocumentFileFailure(error: AxiosError) {
  return {
    type: DOCUMENT_FILE__DOWNLOAD_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchDocumentFile(payload: { documentId: string }) {
  return {
    type: DOCUMENT_FILE__FETCH_REQUEST,
    payload,
  };
}

export function fetchDocumentFileSuccess(payload: { url: string }) {
  return {
    type: DOCUMENT_FILE__FETCH_SUCCESS,
    payload,
  };
}

export function fetchDocumentFileFailure(error: AxiosError) {
  return {
    type: DOCUMENT_FILE__FETCH_FAILURE,
    payload: error,
    error: true,
  };
}

export type DocumentFileAction =
  | ReturnType<typeof downloadDocumentFile>
  | ReturnType<typeof downloadDocumentFileSuccess>
  | ReturnType<typeof downloadDocumentFileFailure>
  | ReturnType<typeof fetchDocumentFile>
  | ReturnType<typeof fetchDocumentFileSuccess>
  | ReturnType<typeof fetchDocumentFileFailure>;
